import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TariffService } from '@app/driver-tariffs/services/tariff.service';
import { Tariff } from '@app/driver-tariffs/tariff';
import { MatDialog } from '@angular/material';
import { DeleteDialogComponent } from '@app/driver-tariffs/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-tariffs-list',
  templateUrl: './tariffs-list.component.html',
  styleUrls: ['./tariffs-list.component.scss']
})
export class TariffsListComponent implements OnInit {
  @Output() tariffSelected = new EventEmitter<Tariff>();

  @Input() selectedTariffId;
  selectObj;

  constructor(public tariffService: TariffService, private dialog: MatDialog) {}

  ngOnInit() {
    this.tariffService.currentTariff.subscribe((obj: any) => {
      obj.id ? (this.selectObj = obj) : null;
    });
    this.tariffService.tariffsList.subscribe(res => {
      let selectedTariff;
      if (this.selectObj) {
        selectedTariff = res.find(el => el.id === this.selectObj.id);
        this.select(selectedTariff);
      } else {
        res[0] ? this.select(res[0]) : null;
      }
      this.tariffService.serviceTracker.subscribe((id: number) => {
        if (this.selectObj && this.selectObj.service_id !== id) {
          res[0] ? this.select(res[0]) : null;
        }
      });
    });
  }

  select(tariff) {
    if (tariff) {
      this.selectedTariffId = tariff.id;
      this.tariffSelected.emit(tariff);
    }
  }

  removeItem(tariff) {
    this.dialog
      .open(DeleteDialogComponent, {
        data: {
          message: 'TARIFF_REMOVE_MSG'
        }
      })
      .afterClosed()
      .subscribe(res => {
        console.log(res);
        if (res) {
          this.tariffService.removeTariff(tariff);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/tariffs-list/tariffs-list.component.ts